import { ChevronDownIcon, type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

/** The summary remains useful while closed; the complete public text is one tap away. */
export function InfoDisclosure({
  title,
  summary,
  icon: Icon,
  children,
  open = false,
}: {
  title: string;
  summary?: string | undefined;
  icon: LucideIcon;
  children: ReactNode;
  open?: boolean;
}) {
  return (
    <details open={open} className="group board-pane min-w-0 rounded-xl border bg-card">
      <summary className="flex cursor-pointer list-none items-start gap-3 p-5 focus-visible:outline-2 focus-visible:outline-ring [&::-webkit-details-marker]:hidden">
        <Icon className="mt-0.5 size-5 shrink-0 text-muted-foreground" aria-hidden="true" />
        <span className="min-w-0 flex-1">
          <span className="block text-lg font-semibold leading-tight">{title}</span>
          {summary && (
            <span className="mt-1.5 line-clamp-2 break-words text-sm leading-relaxed text-muted-foreground group-open:hidden">
              {summary}
            </span>
          )}
        </span>
        <ChevronDownIcon
          className="mt-0.5 size-5 shrink-0 text-muted-foreground transition-transform group-open:rotate-180"
          aria-hidden="true"
        />
      </summary>
      <div className="border-t px-5 py-4">{children}</div>
    </details>
  );
}
